import React from "react";
import { Ambulance, Phone, Shield, UserRound } from "lucide-react";
import { ICON_STROKE } from "../../ui/icon";

const NUMBERS = [
  { number: "112", labelKey: "public.sosEmergency", icon: Phone, variant: "112" },
  { number: "108", labelKey: "public.sosAmbulance", icon: Ambulance, variant: "108" },
  { number: "100", labelKey: "public.sosPolice", icon: Shield, variant: "100" },
  { number: "181", labelKey: "public.sosWomen", icon: UserRound, variant: "181" },
];

const PublicStickyCallBar = ({ t }) => (
  <nav className="pub-sticky-call" aria-label={t("public.sosBarLabel")}>
    <div className="pub-sticky-call__inner">
      {NUMBERS.map(({ number, labelKey, icon: Icon, variant }) => (
        <a key={number} href={`tel:${number}`} className={`pub-sticky-call__btn pub-sticky-call__btn--${variant}`}>
          <span className="pub-sticky-call__number">
            <Icon size={16} strokeWidth={ICON_STROKE} aria-hidden />
            {number}
          </span>
          <span className="pub-sticky-call__label">{t(labelKey)}</span>
        </a>
      ))}
    </div>
  </nav>
);

export default PublicStickyCallBar;
